
import { flickityAutoScroll } from './flickityAutoScroll'


export default () => {
	const els = [...document.querySelectorAll('.gallery-carousel')]
	els.map(el => {
		const carouselEl = el.querySelector('.gallery-carousel__inner')
		flickityAutoScroll(carouselEl)
	})	
}